module.exports = __webpack_public_path__ + "assets/img/ssl.1977596a.png";